import React, { SVGProps } from 'react'
const SvgReceiptUpload = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      clipPath="url(#Receipt-Upload_svg__a)"
      clipRule="evenodd"
    >
      <path d="M5 4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0V5A1.5 1.5 0 0 1 5 3.5h3a.5.5 0 0 1 0 1H5ZM19.5 5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1 0-1h3A1.5 1.5 0 0 1 20.5 5v3a.5.5 0 0 1-1 0V5ZM19 19.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 1 0v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3ZM4.5 19a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1H5A1.5 1.5 0 0 1 3.5 19v-3a.5.5 0 0 1 1 0v3ZM8.993 8.5c-.05 0-.092.04-.092.091v7.136l.994-.917c.227-.21.57-.23.82-.048l1.22.887 1.098-.88a.648.648 0 0 1 .745-.045l1.07.659V8.59c0-.05-.04-.091-.09-.091H8.992ZM7.9 8.591c0-.602.489-1.091 1.092-1.091h5.764c.603 0 1.092.489 1.092 1.091v7.422a.648.648 0 0 1-.988.552l-1.396-.86-1.116.893a.648.648 0 0 1-.785.018l-1.203-.875-1.372 1.266a.648.648 0 0 1-1.088-.476v-7.94Z" />
      <path d="M9.675 12a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM9.675 10.066a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" />
    </g>
    <defs>
      <clipPath id="Receipt-Upload_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgReceiptUpload
